import { useSelector } from 'react-redux';
import { selectTransactionsSplitViewMode } from 'store/transactionsSlice/transactionsSelectors';

export default function useIsSplitViewMode() {
    return useSelector(selectTransactionsSplitViewMode);
}
